import { useTranslation } from "react-i18next";
// Functions
import { isClinicOrHome, isPlus } from "../../../../config/validateApplication";
// Components
import { ProtocolHeaderMainDiv, ProtocolHeaderDiv, ProtocolTitle, DaysDiv, DaysText, PlatformFilter } from "./styles";

const PrescriptionsHeader = ({ software, activityType, isARSection, platformFilter, setPlatformFilter }) => {
  const [t] = useTranslation("global");

  const handleSetPlatformFilter = (e) => {
    e.preventDefault();
    const platformFilters = ["", "MOBILE_PHONE", "MOBILE_TABLET", "WEB_NONE"];
    const currentFilterIndex = platformFilters.indexOf(platformFilter);
    setPlatformFilter(platformFilters[currentFilterIndex + 1] ? platformFilters[currentFilterIndex + 1] : "");
  };

  return (
    <ProtocolHeaderMainDiv>
      <ProtocolHeaderDiv>
        <ProtocolTitle
          width={isClinicOrHome(software) ? "335px" : isARSection ? "295px" : "385px"}
          padding={activityType ? "0" : "0 0 0 110px"}
        >
          {t(activityType ? activityType : "activity").toUpperCase()}
        </ProtocolTitle>
        {isARSection && (
          <ProtocolTitle width="90px" padding="0 10px 0 0" textAlignCenter>
            {t("supportProtocols_supportTittle")}
          </ProtocolTitle>
        )}
        <DaysDiv>
          <DaysText>{t("prescriptions_tableProtocolDays_monday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_tuesday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_wednesday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_thursday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_friday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_saturday")}</DaysText>
          <DaysText>{t("prescriptions_tableProtocolDays_sunday")}</DaysText>
        </DaysDiv>
        {isClinicOrHome(software) && (
          <ProtocolTitle width="80px" padding="0 0 0 18px">
            {t("prescriptions_tableBonusText")}
          </ProtocolTitle>
        )}
        <ProtocolTitle padding={isClinicOrHome(software) ? "0" : "0 0 0 28px"} width={isClinicOrHome(software) ? "118px" : "150px"}>
          {t(isPlus(software) && activityType === "prescriptions_fullBodyActivities" ? "settings" : "duration").toUpperCase()}
        </ProtocolTitle>
        <ProtocolTitle>{t("reports").toUpperCase()}</ProtocolTitle>
        {isPlus(software) && <PlatformFilter onClick={handleSetPlatformFilter}>{t("prescriptions_platforms")}</PlatformFilter>}
      </ProtocolHeaderDiv>
    </ProtocolHeaderMainDiv>
  );
};

export default PrescriptionsHeader;
